import { createSlice } from '@reduxjs/toolkit';

import {
  serviceGetDashboard,
} from 'utils';

const initialState = {
  data: null,
  isLoaded: true,
  success: false,
  error: false
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    dataRequest(state, action) {
      return { ...state, isLoaded: true };
    },

    dataSuccess(state, action) {
      const data = action.payload;

      let totalSuccess = 0;
      let totalFailed = 0;
      let valuesFailed = [];
      let valuesSuccess = [];
      let labels = [];
      let workflows = data.workflows.map(workflow => {
        const objectResult = {
          name: workflow.name,
          successRate: 0,
          jobs: workflow.jobs,
          type: workflow.type_template,
          wf_definition: workflow.wf_definition,
          worktemplate_id: workflow.worktemplate_id
        };

        if (workflow?.jobs) {
          let count = workflow.jobs.reduce((acum, current) => {
            if (current.status === 'OK') return acum += 1;
            else return acum;
          }, 0);
          if (!count) {
            objectResult.successRate = '0%';
          }
          else {
            const val = (count / workflow.jobs.length) * 100;
            if (isNaN(val)){
              objectResult.successRate = "  ";
            } else {
              objectResult.successRate = `${val.toFixed(2)}%`
            }
            
          }
        }
        return objectResult;
      })

      data.jobs.forEach((job, i) => {
        totalSuccess += Number(job.ok);
        totalFailed += Number(job.er);
        valuesFailed.push({ x: job.fecha, y: job.er });
        valuesSuccess.push({ x: job.fecha, y: job.ok });
        labels.push(job.fecha);
      });

      const objectData = {
        kpi: {
          projects: data.proyectosEjecutados,
          nodes: data.nodos,
          errors: data.nodosError,
          inventories: data.inventario,
          services: data.modeloServicios
        },
        jobs: {
          labels,
          success: {
            total: totalSuccess,
            values: valuesSuccess
          },
          failed: {
            total: totalFailed,
            values: valuesFailed
          }
        },
        workflows: workflows
      };

      return {
        ...state,
        isLoaded: false,
        success: true,
        data: objectData || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: false,
        error: action.payload.data?.message || true
      };
    },

    cleanUpDashboard(state) {
      return initialState;
    },

    cleanUpMessageDashboard(state) {
      return {
        ...state,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },
  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpDashboard,
  cleanUpMessageDashboard
} = dashboardSlice.actions;

const fetchGetDashboard = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetDashboard(args)
      .then((response) => dispatch(dataSuccess(response.data)))
      .catch((err) => dispatch(dataFailure(err)));
  };
};

export {
  fetchGetDashboard,
  cleanUpDashboard,
  cleanUpMessageDashboard
};

export default dashboardSlice.reducer;
